import { HttpClient } from '@angular/common/http';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HttpLoader implements TranslocoLoader {
  readonly http = inject(HttpClient);

  getTranslation(langPath: string): Observable<Translation> {
    const normalized = langPath.replace(/^\/+/, '');
    return this.http.get<Translation>(`/assets/i18n/${normalized}.json`);
  }
}
